// src/hooks/usePrototypes.js

import { useEffect, useState } from 'react';

export default function usePrototypes() {
  const [data,    setData]    = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    let canceled = false;

    fetch('/api/prototypes')
      .then(r => r.ok ? r.json() : Promise.reject(r))
      .then(json => { if (!canceled) { setData(json); setLoading(false); } })
      .catch(err  => { if (!canceled) { setError(err); setLoading(false); } });

    return () => { canceled = true; };
  }, []);

  return { data, loading, error };
}
